module.exports = __webpack_public_path__ + "img/file-plus.c38b2473.svg";